// Radix Select does not accept an empty value, so "no filter" is this sentinel
export const ALL = 'all';

export const toSelectValue = (value?: number) => (value === undefined ? ALL : String(value));
export const fromSelectValue = (value: string) => (value === ALL ? undefined : Number(value));
